// @flow
import type { ModularUIModel } from "../models";

export type TargetModel = Class<ModularUIModel> | Array<Class<ModularUIModel>>;
